module.exports = __webpack_public_path__ + "img/quality-banner.213e2da2.png";